const styles = (theme) => ({
  root: {
    '& .ItemIcon': {
      backgroundColor: theme.palette.background.lighter,
      color: theme.palette.custom.accounts,
    },
  },
  bodyContainer: {
    marginTop: theme.spacing.unit * 3.5,
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing.unit * 4,
      marginBottom: theme.spacing.unit * 1.5,
    },
  },
  cardTitleLarge: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.125rem',
    },
  },
  subtitle: {
    [theme.breakpoints.up('md')]: {
      marginTop: 5,
    },
  },
});

export default styles;
